import React from 'react';

/** In a footer row, `block` means an equal share of the row, not the full width, so the buttons match. */
export const footerButtonStyle = (block?: boolean): React.CSSProperties =>
  block ? { flex: 1, minWidth: 0 } : { minWidth: 100 };
